import { camelCase, get } from "lodash";
import { StatusValues } from "../ResourceStatus/ResourceStatus";
import { SearchResultsItem } from "./SearchContents";
import { ResultColumn } from "./SearchResults";
import { ResultsEntity } from "../../types/funnelback/Response";

const formatSearchResults = (
    items: ResultsEntity[],
    columns: ResultColumn[]
): SearchResultsItem[] =>
    items.map((item): SearchResultsItem => {
        const formattedItem: Partial<SearchResultsItem> = {};
        columns.forEach((columnDef) => {
            const { funnelbackField, columnKey } = columnDef;
            formattedItem[columnKey] = get(item, funnelbackField);
        });

        const status = item.metaData?.status || "";
        if ("status" in formattedItem) {
            formattedItem.status = formattedItem?.status
                ? (camelCase(formattedItem.status) as StatusValues)
                : (camelCase(status) as StatusValues);
        }

        return formattedItem;
    });

export default formatSearchResults;
